import { gql } from '@apollo/client';

export const GRADES_REQUEST = gql`
  query grades(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    grades(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      grades {
        id
        status
        name
        description
        createdAt
        photos
        specsSheet
        subCategory {
          id
          name
          productSubCategory
        }
        mfi
        manufacturer
        productSubCategoryManufacturer
        gradeType
        applications
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
    }
  }
`;

// export const CATEGORY_REQUEST = gql`
//   query category(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     category(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       category {
//         id
//         createdAt
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

export const CATEGORY_LIST = gql`
  query categoryList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    categoryList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      categoryList {
        id
        name
        status
        photo
        document
        createdAt
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
    }
  }
`;

export const PRODUCT_LIST = gql`
  query productList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    productList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      productList {
        id
        name
        status
        photo
        document
        createdAt
        createdByUserId
        updatedByUserId
        category {
          id
          name
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const PRODUCT_LIST_SUBSCRIPTION = gql`
  subscription grades(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    productList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      product {
        id
        name
        status
        photo
        document
        createdAt
        createdByUserId
        updatedByUserId
        category {
          id
          name
        }
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const SUBCATEGORY_LIST = gql`
  query subCategoryList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    subCategoryList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      subCategoryList {
        id
        name
        status
        photo
        document
        createdAt
        createdByUserId
        updatedByUserId
        productSubCategory
        product {
          id
          name
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const SUBCATEGORY_LIST_SUBSCRIPTION = gql`
  subscription subCategoryList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    subCategoryList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      subCategory {
        id
        name
        status
        photo
        document
        createdAt
        createdByUserId
        updatedByUserId
        productSubCategory
        product {
          id
          name
        }
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const PRODUCT_BY_NAME = gql`
  query productsByName($name: String) {
    productsByName(name: $name) {
      id
      name
    }
  }
`;

export const SUBCATEGORY_BY_NAME = gql`
  query subcategoriesByName($name: String) {
    subcategoriesByName(name: $name) {
      id
      name
    }
  }
`;

export const GRADES_REQUEST_SUBSCRIPTION = gql`
  subscription grades(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    grades(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      grade {
        id
        status
        name
        description
        createdAt
        photos
        specsSheet
        subCategory {
          id
          name
        }
        mfi
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const GRADE_FAVOURITED_BY_USERS = gql`
  query gradeFavouritedByUsers($gradeId: ID!, $pageNo: Int, $pageSize: Int) {
    gradeFavouritedByUsers(
      gradeId: $gradeId
      pageNo: $pageNo
      pageSize: $pageSize
    ) {
      users {
        username
        traderId
        entityName
        phoneNumber
      }
      totalCount
      totalPages
    }
  }
`;

export const SECTOR_FAVOURITED_BY_USERS = gql`
  query sectorFavouritedByUsers($sectorId: ID!, $pageNo: Int, $pageSize: Int) {
    sectorFavouritedByUsers(
      sectorId: $sectorId
      pageNo: $pageNo
      pageSize: $pageSize
    ) {
      users {
        username
        traderId
        entityName
        phoneNumber
      }
      totalCount
      totalPages
    }
  }
`;

export const CATEGORY_LIST_SUBSCRIPTION = gql`
  subscription categoryList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    categoryList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      category {
        id
        name
        status
        photo
        document
        createdAt
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation createCategory($category: CategoryInput) {
    createCategory(category: $category)
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation updateCategory($category: CategoryInput) {
    updateCategory(category: $category)
  }
`;
export const CREATE_GRADE = gql`
  mutation createGrade($grade: GradeInput) {
    createGrade(grade: $grade)
  }
`;

export const UPDATE_GRADE = gql`
  mutation updateGrade($grade: GradeInput) {
    updateGrade(grade: $grade)
  }
`;

export const DELETE_CATEGORY = gql`
  mutation deleteCategory($id: ID) {
    deleteCategory(id: $id)
  }
`;
export const UPDATE_GRADE_STATUS = gql`
  mutation updateGradeStatus($id: ID, $status: ActiveStatus) {
    updateGradeStatus(id: $id, status: $status)
  }
`;

export const UPDATE_CATEGORY_STATUS = gql`
  mutation updateCategoryStatus($id: ID, $status: ActiveStatus) {
    updateCategoryStatus(id: $id, status: $status)
  }
`;

export const CREATE_PRODUCT = gql`
  mutation createProduct($product: ProductInput) {
    createProduct(product: $product)
  }
`;
export const UPDATE_PRODUCT = gql`
  mutation updateProduct($product: ProductInput) {
    updateProduct(product: $product)
  }
`;
export const CREATE_SUBCATEGORY = gql`
  mutation createSubCategory($subCategory: SubCategoryInput) {
    createSubCategory(subCategory: $subCategory)
  }
`;
export const UPDATE_SUBCATEGORY = gql`
  mutation updateSubCategory($subCategory: SubCategoryInput) {
    updateSubCategory(subCategory: $subCategory)
  }
`;

export const EXPORTS_GRADE = gql`
  query exportGrades(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportGrades(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const EXPORTS_CATEGORIES = gql`
  query exportCategories(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportCategories(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const EXPORTS_PRODUCT = gql`
  query exportProducts(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportProducts(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const EXPORTS_SUB_CATEGORIES = gql`
  query exportSubCategories(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportSubCategories(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;
